import { defineStore } from 'pinia'

import { StoreState } from '@shared/models/interfaces/store'
import { resourcePath } from '@shared/plugins/api'
import { ApiTransport } from '@shared/plugins/api-transport'
import {
  getInitialState,
  updateState,
} from '@shared/utils/store/http-request-state'

import { ChatWidget } from '@protos/apps/pc/chat_widget_pb'

import { ChatWidgetShowDTO } from '@pc/models/proto/dto/chat-widgets'
import { ChatWidgetItemRO } from '@pc/models/proto/ro/chat-widgets'

interface State {
  widget: StoreState<ChatWidget>
}

const state = (): State => ({
  widget: getInitialState(),
})

export const apiTransport = new ApiTransport(resourcePath, 'pc')

export const useChatWidgetsStore = defineStore('chat-widgets', {
  state,

  actions: {
    async getOrFetchWidgetById(dto: { chatWidgetId: number }) {
      if (this.widget?.data?.id === dto.chatWidgetId) {
        return this.widget.data
      }

      return await this.fetchWidgetById(dto)
    },

    async fetchWidgetById(params: { chatWidgetId: number }) {
      this.widget = updateState(this.widget)

      try {
        const resp = await apiTransport.get(
          '/chat_widgets',
          new ChatWidgetShowDTO(params),
          ChatWidgetItemRO
        )

        const { data } = resp ?? {}

        data && this.setWidgetData(data)
        return data
      } catch (error) {
        this.widget = updateState(this.widget, error as Error)
        throw error
      }
    },
    setWidgetData(data: ChatWidget) {
      this.widget = updateState(this.widget, data)
    },
  },
  getters: {
    isKioskModeEnabled: (state) =>
      state.widget?.data?.isKioskModeEnabled ?? false,
  },
})
